import getApiClient from '@/plugins/api-client'

export default {
    loadEvents: function() {
        const self = this,
            api = getApiClient(self.$store)

        const searchParams = JSON.parse(JSON.stringify(self.searchParams))
        Object.keys(searchParams).forEach(function(key) {
            if (searchParams[key] === null || searchParams[key] === '') {
                self.$delete(searchParams, key)
            }

            if (key === 'start[after]' && searchParams[key]) {
                searchParams[key] += ' 00:00:00'
            }

            if (key === 'end[before]' && searchParams[key]) {
                searchParams[key] += ' 23:59:59'
            }
        })

        let params = {
            page: self.currentPage,
            itemsPerPage: self.itemsPerPage,
            ... searchParams
        }

        api.get('/events', {
            params
        })
            .then(result => {
                self.events = result.data['hydra:member']
                self.totalPages = Math.ceil(result.data['hydra:totalItems'] / self.itemsPerPage)
            })
            .catch(error => {
                console.log(error)
            })
    },
    updatePage: function(page) {
        this.currentPage = page
    },
    setOrderStatus(status) {
        delete this.searchParams['status']
        if (status === 'creating') {
            this.searchParams['status'] = status
            this.searchParams['exists[order]'] = false
            this.searchParams['order.status'] = null
        } else {
            this.searchParams['order.status'] = status
            this.searchParams['exists[order]'] = null
        }
    },
    downloadReport: function() {
        const self = this,
            api = getApiClient(self.$store)

        const searchParams = JSON.parse(JSON.stringify(self.searchParams))
        Object.keys(searchParams).forEach(function(key) {
            if (searchParams[key] === null || searchParams[key] === '') {
                self.$delete(self.searchParams, key)
            }

            if (key === 'start[after]' && searchParams[key]) {
                searchParams[key] += ' 00:00:00'
            }

            if (key === 'end[before]' && searchParams[key]) {
                searchParams[key] += ' 23:59:59'
            }
        })

        api.get('/events/export', {
            responseType: 'blob',
            params: searchParams
        })
            .then(result => {
                const url = window.URL.createObjectURL(new Blob([result.data])),
                    link = document.createElement('a')

                link.href = url;
                link.setAttribute('download', 'export.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                console.log(error)
            })

    }
}
